<template>
  <div>
    <PageTitle
      title="Sales"
      :btnCreate="true"
      :saleVisible="true"
      :createRoute="'/sales/new'"
      :permission="'Product Create'"
    />

    <v-container
      fluid
      class="lighten-12 container"
      style="background-color: white"
    >
      <v-row>
        <v-col
          cols="12"
          lg="4"
          md="12"
          xl="4"
          xs="12"
          sm="12"
          v-for="i in [
            'linear-gradient(to right, rgb(0 226 9) 0%, rgb(76 175 80) 100%)',
          ]"
          :key="i"
        >
          <v-card
            class="lighten-12 card-content py-0 topCard"
            width="100%"
            :color="i"
            :style="'background:' + i"
          >
            <v-row style="color: white">
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                class="text-lg-left font-weight-bold"
              >
                <div class="topCard ml-3">Total</div>
              </v-col>
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                class="text-end font-weight-bold"
              >
                <div class="topCard mr-3">
                  {{ grandTotal | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          md="12"
          v-for="i in ['linear-gradient(to right, #00c5fb 0%, #0253cc 100%)']"
          :key="i"
        >
          <v-card class="mx-auto" :color="i" :style="'background:' + i">
            <v-row style="color: white">
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                xl="6"
                class="text-lg-left font-weight-bold"
              >
                <div class="topCard ml-3 text-no-wrap">Discount amount</div>
              </v-col>
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                xl="6"
                class="text-end font-weight-bold"
              >
                <div class="topCard mr-3">
                  {{ discountTotal | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          md="12"
          v-for="i in ['linear-gradient(to right, #be64e2 0%, #851298 100%)']"
          :key="i"
        >
          <v-card class="mx-auto" :color="i" :style="'background:' + i">
            <v-row style="color: white">
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                xl="6"
                class="text-lg-left font-weight-bold"
              >
                <div class="topCard ml-3">Net amount</div>
              </v-col>
              <v-col
                cols="6"
                lg="6"
                sm="6"
                md="6"
                xl="6"
                class="text-end font-weight-bold"
              >
                <div class="topCard mr-3">
                  {{ total | formatCurrency }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content mb-2" v-show="show">
          <TableFilters
            :filters="[
              'customer',
              'search',
              'biller',
              'dateRange',
              'saleType',
              'product',
              'shop',
            ]"
            v-model="filter"
            :columns="columns"
            paginationOptions
          ></TableFilters>
        </v-card>
      </v-expand-transition>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <v-row>
            <v-card-text class="pa-0;fontfam">
              <v-data-table
                :items-per-page="paginationOptions.perPage"
                :headers="headers"
                :items="salesList"
                :single-expand="singleExpand"
                item-key="name"
                hide-default-footer
                @click:row="$router.push(`sales/view/${$event.id}`)"
                class="row-pointer;fontfam"
              >
                <template v-slot:no-data>
                  <noData
                    class="mt-16 container justify-center item-center"
                    name="sales"
                  />
                </template>
                <template v-slot:item.reference_number="{ item }">
                  <div class="p-100">
                    <CopyTableCell
                      :text="item.reference_number"
                    ></CopyTableCell>
                  </div>
                </template>

                <template v-slot:item.date="{ item }">
                  <div class="p-100">
                    {{ item.date ? item.date : '---------' | formatDate }}
                  </div>
                </template>

                <template v-slot:item.customer.name="{ item }">
                  <div class="p-100">
                    {{ item.customer.name ? item.customer.name : '---------' }}
                  </div>
                </template>

                <template v-slot:item.biller="{ item }">
                  <div class="p-100">
                    {{
                      item.biller.first_name
                        ? item.biller.first_name
                        : '---------'
                    }}
                  </div>
                </template>
                <!-- Status -->
                <template v-slot:item.sale_type="{ item }">
                  <v-chip
                    :x-small="true"
                    class="ma-2 f-100"
                    label
                    text-color="white"
                    :color="getSaleTypeColor(item.sale_type)"
                    dark
                    style="
                      color: white;
                      font-variant-caps: all-small-caps;
                      font-weight: bold;
                    "
                    >{{ item.sale_type ? item.sale_type : '---------' }}</v-chip
                  >
                </template>
                <!-- Status -->
                <template v-slot:item.status="{ item }">
                  <div class="d-flex flex-row">
                    <v-chip
                      :x-small="true"
                      class="ma-1 w-100"
                      label
                      text-color="white"
                      :color="getStatusColor(item.status)"
                      dark
                      style="
                        color: white;
                        font-variant-caps: all-small-caps;
                        font-weight: bold;
                      "
                      >{{ item.status ? item.status : '---------' }}</v-chip
                    ><v-tooltip
                      top
                      color="primary"
                      v-if="item.saleReturn.length"
                    >
                      <template v-slot:activator="{ on, attrs }"
                        ><v-icon v-bind="attrs" v-on="on" x-small color="red"
                          >mdi-information</v-icon
                        ></template
                      >Sale Return</v-tooltip
                    >
                  </div>
                </template>
                <!--Total-->
                <template v-slot:item.total="{ item }">
                  <div class="b-100">
                    {{ item.total ? item.total : '---------' | formatCurrency }}
                  </div>
                </template>

                <!--Discount-->
                <template v-slot:item.discount_amount="{ item }">
                  <div class="b-100">
                    {{
                      item.discount_amount
                        ? item.discount_amount
                        : '---------' | formatCurrency
                    }}
                  </div>
                </template>

                <!--Net-->
                <template v-slot:item.grand_total="{ item }">
                  <div class="b-100">
                    {{
                      item.grand_total
                        ? item.grand_total
                        : '---------' | formatCurrency
                    }}
                  </div>
                </template>
                <!--Net-->

                <template v-slot:item.shop.name="{ item }">
                  <div class="p-100">
                    {{
                      ShopView == 'name' ? item.shop.sortform : item.shop.name
                    }}
                  </div>
                </template>
                <!-- Due Amount -->
                <template v-slot:item.due_total="{ item }">
                  <div class="b-100">
                    <span class="deuamount">
                      {{
                        ((item.grand_total ? item.grand_total : 0) -
                          (item.paid_amount ? item.paid_amount : 0))
                          | formatCurrency
                      }}
                    </span>
                  </div>
                </template>

                <!-- Action -->
                <template v-slot:item.action="{ item }">
                  <v-menu offset-y transition="scroll-y-transition">
                    <template v-slot:activator="{ $attrs, on }">
                      <v-icon v-bind="$attrs" v-on="on"
                        >mdi-dots-vertical</v-icon
                      >
                    </template>
                    <v-list class="actions">
                      <permission-control permissionName="Sales Show">
                        <v-list-item
                          @click="$router.push('sales/view/' + item.id)"
                          link
                        >
                          <span>
                            <v-icon v-bind="$attrs" v-on="on">mdi-eye</v-icon
                            >View
                          </span>
                        </v-list-item>
                      </permission-control>
                    </v-list>
                  </v-menu>
                </template>
                <template
                  slot="footer"
                  v-if="salesList && salesList.length > 0"
                  class="black--text"
                >
                  <v-row>
                    <v-col sm="6" md="10" lg="10" class="title pl-6"
                      >Total</v-col
                    >
                    <v-col
                      class="title text-lg-center text-md-left text-right pr-0 pr-sm-15 pr-md-15 pr-lg-5"
                    ></v-col>
                  </v-row>
                </template>

                <template
                  slot="body.append"
                  v-if="salesList && salesList.length > 0"
                >
                </template>

                <template v-slot:footer>
                  <pagination
                    @paginationOptions="setPaginationOptions"
                    @response="setResponseData"
                    @getPageNumber="setPagenumber"
                    url="sales"
                    :filterAction="true"
                    :filter="filter"
                  />
                </template>
              </v-data-table>
            </v-card-text>
          </v-row>
        </v-container>
      </v-card>
      <!-- </v-card> -->
      <div class="d-flex justify-center align-center"></div>
    </v-container>
  </div>
</template>
<script>
import pagination from '../../modules/shared/components/pagination.vue';
import confirmation from '../../modules/shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import { mapState } from 'vuex';
import noData from '../../components/shared/noItem';

export default {
  components: {
    TableFilters,
    pagination,
    noData,
  },
  data() {
    return {
      on: {
        click: console.log,
        contextmenu: console.log,
      },
      show: false,
      singleExpand: false,
      paginationOptions: {},
      isLoading: true,
      total: 0,
      grandTotal: 0,
      discountTotal: 0,
      columns: [
        {
          text: 'Date',
          value: 'date',
          show: true,
          disabled: false,
          width: '8.3%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Reference Number',
          value: 'reference_number',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'sale_type',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Shop',
          value: 'shop.name',
          show: true,
          disabled: false,
          align: 'left',
          width: '8.3%%',
          sortable: false,
          // absolute: true,
        },
        {
          text: 'Biller',
          value: 'biller',
          show: true,
          disabled: false,
          align: 'center',
          width: '8.3%%',
          sortable: false,
        },
        {
          text: 'Customer',
          value: 'customer.name',
          show: true,
          disabled: false,
          align: 'center',
          width: '8.3%%',
          sortable: false,
        },

        {
          text: 'Total',
          value: 'total',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Discount',
          value: 'discount_amount',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'right',
          sortable: false,
        },
        {
          text: 'Net',
          value: 'grand_total',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Due ',
          value: 'due_total',
          show: true,
          disabled: false,
          width: '8.3%%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          show: true,
          disabled: false,
          width: '8.3%',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          show: true,
          disabled: false,
          width: '8.3%',
          align: 'center',
          sortable: false,
        },
      ],
      salesList: [],
      filter: {
        name: '',
        customer: '',
        start: '',
        end: '',
        shop: '',

        search: '',
        status: '',
      },
      products: [],
    };
  },
  methods: {
    getStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;

        case 'Partially Paid':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;

        default:
          break;
      }
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    getSaleTypeColor(saletype) {
      switch (saletype) {
        case 'Cash':
          return 'green';
          break;
        case 'Credit':
          return 'red';
          break;
        default:
          break;
      }
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    clearFilter() {
      this.filter = {};
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseFloat(element[filed]);
      });
      return value;
    },

    setResponseData(sales) {
      this.salesList = sales;
      this.total = this.sumField(this.salesList, 'grand_total');
      this.grandTotal = this.sumField(this.salesList, 'total');
      this.discountTotal = this.sumField(this.salesList, 'discount_amount');
    },
    openConfirmation(supplierdetail) {
      confirmation.dialog = true;
      this.$confirm(
        'Do you want to ' +
          (supplierdetail.status ? 'Archive  ' : 'Activate ') +
          supplierdetail.name +
          '?',
      ).then((res) => {
        if (res) {
          this.GetArchiveMsgs(supplierdetail);
        }
      });
    },
  },
  computed: {
    ...mapState(['ShopView']),
    ...mapState(['WarehouseView']),
    // Filter - return selected table fields
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    //this.GetSuppliers();
  },
};
</script>

<style scoped>
.deuamount {
  color: brown;
  font-weight: bold;
}
.fontfam {
  font-family: 'Source Sans Pro', sans-serif !important;
}

.w-100 {
  width: 90px;
  font-weight: 900;
}

.p-100 {
  font-family: 'Source Sans Pro', sans-serif !important;
  /* font-weight: bold; */
}

.b-100 {
  /* font-weight: bold; */
  font-family: 'Source Sans Pro', sans-serif !important;
  text-align: right;
}
.f-100 {
  font-weight: 900;
}
.filterclor {
  color: cornflowerblue;
  font-size: larger;
  font-weight: bold;
}

.min-button::before {
  display: none;
}
</style>
